__turbopack_context__.v({
  "close": "AccordionIcon-module-scss-module__eTz_0a__close",
  "icon": "AccordionIcon-module-scss-module__eTz_0a__icon",
  "transition": "AccordionIcon-module-scss-module__eTz_0a__transition",
});
